import React from 'react';
import clsx from 'clsx';

import './index.scss';
// import modifyImage from 'assets/icon_hensyuu.svg';
import { ReactComponent as ModifyImage } from 'assets/icon_hensyuu.svg';
import { INPUT_URL, CONF_URL, THANKS_URL, ADD_CONF_URL, ADD_THANKS_URL } from 'utils/constant';

const SpTitle = ({ title, path, state }) => {
  const isThanksPage = path.includes('add-thanks') ? true : false;
  const DispTitle = () => {
    return Array.isArray(title) 
      ? title.map(line => (
        <div key={line} className="">
          {line}
          <br />
        </div>
      ))
      : <>{title}</>;
  };
  const { email } = state;
  const ConfTitle = () => {
    return (
      <div>
        下記の内容で派遣依頼のご相談をを送信します。よろしいですか？
      </div>
    );
  };

  const ThanksTitle = () => {
    return (
      <div>
        ご依頼いただいた内容を
        {' '}
        {email}
        {' '}
        に送付いたしました。
      </div>
    );
  };

  const AddConfTitle = () => {
    return (
      <div>
        ご希望と異なる個所は 
        {/* <img className="modify-icon" src={modifyImage} alt="modify" /> */}
        <span className="modify-icon">
          <ModifyImage />
        </span>
        で修正が可能です。
      </div>
    );
  };

  const AddThanksTitle = () => {
    return (
      <div>
        ご依頼いただいた内容を
        {' '}
        {email}
        {' '}
        に送付いたしました。
      </div>
    );
  };

  const subTitle = {
    [CONF_URL]: <ConfTitle />,
    [THANKS_URL]: <ThanksTitle />,
    [ADD_CONF_URL]: <AddConfTitle />,
    [ADD_THANKS_URL]: <AddThanksTitle />,
  };
  return(
  	!title ? <></> :
    <div className="SpTitle">
      <div className={clsx('title', { fit: isThanksPage })}><DispTitle title /></div>
      <div className="subTitle">
        {subTitle[path]}
      </div>
    </div>
  );
};

export default SpTitle;
